import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Home, Building2, Sparkles, Phone, ArrowRight, ChevronDown, UtensilsCrossed, Shirt, Flame, Refrigerator, Microwave, DoorOpen, Warehouse, PanelTop, SunDim, Blinds, BedDouble, Trash2, Fence } from 'lucide-react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { SEOHead } from '../components/SEOHead';
import { BreadcrumbSchema } from '../components/StructuredData';
import { ServiceNav } from '../components/ServiceNav';
const cardClass = 'bg-white rounded-2xl border border-gray-200 p-8 md:p-10 shadow-sm';
const stepHeadingClass = 'font-bebas text-2xl md:text-3xl text-[#1a2744] pb-3 border-b border-gray-200';
const labelClass = 'text-[#1a2744] font-medium text-sm';
const inputClass = 'w-full border border-gray-200 rounded-lg px-4 py-3 bg-white text-[#1a2744] focus:outline-none focus:border-[#e91e8c] focus:ring-1 focus:ring-[#e91e8c] transition-all placeholder-gray-400';
const selectClass = 'w-full border border-gray-200 rounded-lg px-4 py-3 bg-white text-[#1a2744] focus:outline-none focus:border-[#e91e8c] focus:ring-1 focus:ring-[#e91e8c] transition-all appearance-none cursor-pointer';
type PillGroupProps = {
  options: string[];
  selected: string;
  onSelect: (val: string) => void;
};
function PillGroup({
  options,
  selected,
  onSelect
}: PillGroupProps) {
  return <div className="flex flex-wrap gap-3" data-id="element-1164">
      {options.map(opt => <button key={opt} type="button" onClick={() => onSelect(opt)} className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all border ${selected === opt ? 'bg-[#e91e8c] border-[#e91e8c] text-white shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:border-[#e91e8c] hover:text-[#e91e8c]'}`} data-id="element-1165">
          {opt}
        </button>)}
    </div>;
}
const extras = [{
  name: 'Washing dishes',
  price: 7,
  icon: UtensilsCrossed
}, {
  name: 'Laundry (wash & fold)',
  price: 7,
  icon: Shirt
}, {
  name: 'Inside of oven',
  price: 7,
  icon: Flame
}, {
  name: 'Inside of fridge',
  price: 7,
  icon: Refrigerator
}, {
  name: 'Inside microwave',
  price: 7,
  icon: Microwave
}, {
  name: 'Interior of Kitchen Cabinets',
  price: 7,
  icon: DoorOpen
}, {
  name: 'Finished Basement',
  price: 7,
  icon: Warehouse
}, {
  name: 'Hand Wipe Baseboards',
  price: 7,
  icon: PanelTop
}, {
  name: 'Interior Windows',
  price: 7,
  icon: SunDim
}, {
  name: 'Wet Wipe Blinds',
  price: 7,
  icon: Blinds
}, {
  name: 'Change Sheets',
  price: 7,
  icon: BedDouble
}, {
  name: 'Property Cleanup',
  price: 7,
  icon: Trash2
}, {
  name: 'Patio or Balcony',
  price: 7,
  icon: Fence
}];
const timeSlots = ['14:00', '15:00'];
export function MoveInMoveOutQuote() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Step 1 - Contact
  const [contact, setContact] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });
  const handleContactChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setContact({
      ...contact,
      [e.target.name]: e.target.value
    });
  };
  // Step 2 - Location
  const [location, setLocation] = useState({
    address: '',
    unit: '',
    city: '',
    postalCode: ''
  });
  const handleLocationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocation({
      ...location,
      [e.target.name]: e.target.value
    });
  };
  // Step 3 - Cleaning details
  const [hours, setHours] = useState('2');
  const [cleaners, setCleaners] = useState('1');
  const [bedrooms, setBedrooms] = useState('');
  const [bathrooms, setBathrooms] = useState('');
  const [additionalRooms, setAdditionalRooms] = useState('');
  const [sqFeet, setSqFeet] = useState('');
  const [access, setAccess] = useState('');
  const [homeStatus, setHomeStatus] = useState('');
  const [parking, setParking] = useState('');
  // Step 4 - Extras
  const [selectedExtras, setSelectedExtras] = useState<string[]>([]);
  const toggleExtra = (name: string) => {
    setSelectedExtras(prev => prev.includes(name) ? prev.filter(e => e !== name) : [...prev, name]);
  };
  // Step 5 - Date & Time
  const [date, setDate] = useState('');
  const [timeSlot, setTimeSlot] = useState('');
  // Step 6 - Access details
  const [accessDetails, setAccessDetails] = useState('');
  return <div className="min-h-screen w-full font-sans bg-white flex flex-col" data-id="element-1166">
      <SEOHead title="Book Move-In / Move-Out Cleaning | Smith & Jengs Cleaning Services" description="Book your move-in or move-out cleaning service in Bicester and Oxfordshire. End of tenancy cleaning, online booking in 60 seconds." canonical="https://smithandjengs.com/move-in-move-out-quote" data-id="element-1167" />
      <BreadcrumbSchema items={[{
      name: 'Home',
      url: 'https://smithandjengs.com/'
    }, {
      name: 'Move-In / Move-Out',
      url: 'https://smithandjengs.com/move-in-move-out-quote'
    }, {
      name: 'Book Online',
      url: 'https://smithandjengs.com/move-in-move-out-quote'
    }]} data-id="element-1168" />
      <Navbar data-id="element-1169" />

      <main className="flex-1 pt-24" data-id="element-1170">
        <ServiceNav data-id="element-1171" />

        {/* Header */}
        <section className="w-full bg-white pt-12 md:pt-16 pb-12 px-4 md:px-12" data-id="element-1172">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="max-w-5xl w-full mx-auto text-center" data-id="element-1173">
            <h1 className="font-bebas text-[#1a2744] leading-[0.85] tracking-wide mb-6" data-id="element-1174">
              <span className="text-5xl md:text-6xl lg:text-7xl block" data-id="element-1175">
                BOOK ONLINE
              </span>
              <span className="text-3xl md:text-4xl lg:text-5xl block text-[#e91e8c]" data-id="element-1176">
                MOVE-IN / MOVE-OUT
              </span>
            </h1>
            <p className="text-gray-600 font-medium max-w-2xl mx-auto text-lg" data-id="element-1177">
              Book your before/after move cleaning in 60 seconds. End of tenancy
              cleaning made simple.
            </p>
          </motion.div>
        </section>

        {/* Form Section */}
        <section className="w-full bg-[#f8f9fa] py-12 md:py-16 px-4 md:px-8" id="booking-form" data-id="element-1178">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="max-w-4xl w-full mx-auto" data-id="element-1179">
            <form className="space-y-8" onSubmit={e => e.preventDefault()} data-id="element-1180">
              {/* STEP 1: Contact */}
              <div className={cardClass} data-id="element-1181">
                <h3 className={stepHeadingClass} data-id="element-1182">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1183">STEP 1:</span> Contact
                  Information
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-1184">
                  <div className="space-y-2" data-id="element-1185">
                    <label className={labelClass} data-id="element-1186">First Name</label>
                    <input type="text" name="firstName" value={contact.firstName} onChange={handleContactChange} placeholder="First Name" className={inputClass} data-id="element-1187" />
                  </div>
                  <div className="space-y-2" data-id="element-1188">
                    <label className={labelClass} data-id="element-1189">Last Name</label>
                    <input type="text" name="lastName" value={contact.lastName} onChange={handleContactChange} placeholder="Last Name" className={inputClass} data-id="element-1190" />
                  </div>
                  <div className="space-y-2" data-id="element-1191">
                    <label className={labelClass} data-id="element-1192">Email</label>
                    <input type="email" name="email" value={contact.email} onChange={handleContactChange} placeholder="Email Address" className={inputClass} data-id="element-1193" />
                  </div>
                  <div className="space-y-2" data-id="element-1194">
                    <label className={labelClass} data-id="element-1195">Phone Number</label>
                    <input type="tel" name="phone" value={contact.phone} onChange={handleContactChange} placeholder="Phone Number" className={inputClass} data-id="element-1196" />
                  </div>
                </div>
              </div>

              {/* STEP 2: Location */}
              <div className={cardClass} data-id="element-1197">
                <h3 className={stepHeadingClass} data-id="element-1198">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1199">STEP 2:</span> Cleaning
                  Location
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-1200">
                  <div className="space-y-2" data-id="element-1201">
                    <label className={labelClass} data-id="element-1202">Street Address</label>
                    <input type="text" name="address" value={location.address} onChange={handleLocationChange} placeholder="Enter a location" className={inputClass} data-id="element-1203" />
                  </div>
                  <div className="space-y-2" data-id="element-1204">
                    <label className={labelClass} data-id="element-1205">Unit/Apt/Suite #</label>
                    <input type="text" name="unit" value={location.unit} onChange={handleLocationChange} placeholder="Unit/Apt/Suite #" className={inputClass} data-id="element-1206" />
                  </div>
                  <div className="space-y-2" data-id="element-1207">
                    <label className={labelClass} data-id="element-1208">City</label>
                    <input type="text" name="city" value={location.city} onChange={handleLocationChange} placeholder="City" className={inputClass} data-id="element-1209" />
                  </div>
                  <div className="space-y-2" data-id="element-1210">
                    <label className={labelClass} data-id="element-1211">Postal Code</label>
                    <input type="text" name="postalCode" value={location.postalCode} onChange={handleLocationChange} placeholder="Postal Code" className={inputClass} data-id="element-1212" />
                  </div>
                </div>
              </div>

              {/* STEP 3: Cleaning Details */}
              <div className={cardClass} data-id="element-1213">
                <h3 className={stepHeadingClass} data-id="element-1214">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1215">STEP 3:</span> Tell Us
                  About the Cleaning
                </h3>
                <p className="text-sm text-gray-500 mt-3" data-id="element-1216">
                  All cleaning include cleaning the kitchen.
                </p>
                <div className="space-y-6 mt-8" data-id="element-1217">
                  {/* Hours & Cleaners */}
                  <div data-id="element-1218">
                    <label className={`${labelClass} block mb-3`} data-id="element-1219">
                      How many hours and cleaners would you like to book?
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-1220">
                      <div className="relative" data-id="element-1221">
                        <select value={hours} onChange={e => setHours(e.target.value)} className={selectClass} data-id="element-1222">
                          {[2, 3, 4, 5, 6, 7, 8].map(h => <option key={h} value={String(h)} data-id="element-1223">
                              {h} Hours
                            </option>)}
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1224" />
                      </div>
                      <div className="relative" data-id="element-1225">
                        <select value={cleaners} onChange={e => setCleaners(e.target.value)} className={selectClass} data-id="element-1226">
                          {[1, 2, 3, 4].map(c => <option key={c} value={String(c)} data-id="element-1227">
                              {c} Cleaner{c > 1 ? 's' : ''}
                            </option>)}
                        </select>
                        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1228" />
                      </div>
                    </div>
                  </div>

                  {/* Bedrooms */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1229">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1230">
                      Bedrooms
                    </label>
                    <div className="relative md:w-64" data-id="element-1231">
                      <select value={bedrooms} onChange={e => setBedrooms(e.target.value)} className={selectClass} data-id="element-1232">
                        <option value="" disabled data-id="element-1233">
                          Select
                        </option>
                        <option value="studio" data-id="element-1234">Studio / 1 Bedroom</option>
                        <option value="2" data-id="element-1235">2 Bedrooms</option>
                        <option value="3" data-id="element-1236">3 Bedrooms</option>
                        <option value="4" data-id="element-1237">4 Bedrooms</option>
                        <option value="5+" data-id="element-1238">5+ Bedrooms</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1239" />
                    </div>
                  </div>

                  {/* Bathrooms */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1240">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1241">
                      Bathrooms
                    </label>
                    <div className="relative md:w-64" data-id="element-1242">
                      <select value={bathrooms} onChange={e => setBathrooms(e.target.value)} className={selectClass} data-id="element-1243">
                        <option value="" disabled data-id="element-1244">
                          Select
                        </option>
                        <option value="1" data-id="element-1245">1 Bathroom</option>
                        <option value="2" data-id="element-1246">2 Bathrooms</option>
                        <option value="3" data-id="element-1247">3 Bathrooms</option>
                        <option value="4+" data-id="element-1248">4+ Bathrooms</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1249" />
                    </div>
                  </div>

                  {/* Additional Rooms */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1250">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1251">
                      Additional Rooms (dining room, living room, office, etc)
                    </label>
                    <div className="relative md:w-64" data-id="element-1252">
                      <select value={additionalRooms} onChange={e => setAdditionalRooms(e.target.value)} className={selectClass} data-id="element-1253">
                        <option value="" disabled data-id="element-1254">
                          Select
                        </option>
                        <option value="0" data-id="element-1255">No additional rooms</option>
                        <option value="1" data-id="element-1256">1</option>
                        <option value="2" data-id="element-1257">2</option>
                        <option value="3" data-id="element-1258">3</option>
                        <option value="4+" data-id="element-1259">4+</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1260" />
                    </div>
                  </div>

                  {/* Total Square Feet */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1261">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1262">
                      Total Square feet? (incl. Basement)
                    </label>
                    <div className="relative md:w-64" data-id="element-1263">
                      <select value={sqFeet} onChange={e => setSqFeet(e.target.value)} className={selectClass} data-id="element-1264">
                        <option value="" disabled data-id="element-1265">
                          Select
                        </option>
                        <option value="less-than-1000" data-id="element-1266">Less than 1000</option>
                        <option value="1000-2000" data-id="element-1267">1000 - 2000</option>
                        <option value="2000-3000" data-id="element-1268">2000 - 3000</option>
                        <option value="3000+" data-id="element-1269">3000+</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1270" />
                    </div>
                  </div>

                  {/* How do we access */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1271">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1272">
                      How do we access the premises?
                    </label>
                    <div className="relative md:w-64" data-id="element-1273">
                      <select value={access} onChange={e => setAccess(e.target.value)} className={selectClass} data-id="element-1274">
                        <option value="" disabled data-id="element-1275">
                          Select
                        </option>
                        <option value="meet" data-id="element-1276">
                          I will meet you at the location
                        </option>
                        <option value="lockbox" data-id="element-1277">Lock box</option>
                        <option value="keys" data-id="element-1278">Pick up keys</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1279" />
                    </div>
                  </div>

                  {/* Status of the home */}
                  <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-6" data-id="element-1280">
                    <label className={`${labelClass} md:flex-1`} data-id="element-1281">
                      Status of the home...
                    </label>
                    <div className="relative md:w-64" data-id="element-1282">
                      <select value={homeStatus} onChange={e => setHomeStatus(e.target.value)} className={selectClass} data-id="element-1283">
                        <option value="" disabled data-id="element-1284">
                          Select
                        </option>
                        <option value="empty" data-id="element-1285">Completely Empty</option>
                        <option value="partial" data-id="element-1286">Partially Furnished</option>
                        <option value="furnished" data-id="element-1287">Fully Furnished</option>
                      </select>
                      <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" data-id="element-1288" />
                    </div>
                  </div>

                  {/* Parking */}
                  <div className="space-y-3" data-id="element-1289">
                    <label className={labelClass} data-id="element-1290">Parking</label>
                    <PillGroup options={['Free on street', 'Free home parking', 'Parking meters', 'Paid parking lot']} selected={parking} onSelect={setParking} data-id="element-1291" />
                  </div>
                </div>
              </div>

              {/* STEP 4: Extras */}
              <div className={cardClass} data-id="element-1292">
                <h3 className={stepHeadingClass} data-id="element-1293">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1294">STEP 4:</span> Extras?
                </h3>
                <p className="text-sm text-gray-500 mt-3" data-id="element-1295">
                  Free up more of your precious time for what matters most.
                </p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8" data-id="element-1296">
                  {extras.map(({
                  name,
                  price,
                  icon: IconComp
                }) => {
                  const isActive = selectedExtras.includes(name);
                  return <button key={name} type="button" onClick={() => toggleExtra(name)} className={`flex flex-col items-center text-center gap-3 p-5 rounded-xl border-2 transition-all ${isActive ? 'border-[#e91e8c] bg-[#e91e8c]/5 shadow-sm' : 'border-gray-200 bg-white hover:border-[#e91e8c]/40'}`} data-id="element-1297">
                        <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-colors ${isActive ? 'bg-[#e91e8c]/10 text-[#e91e8c]' : 'bg-[#f8f9fa] text-[#1a2744]'}`} data-id="element-1298">
                          <IconComp className="w-6 h-6" data-id="element-1299" />
                        </div>
                        <span className="text-xs font-medium text-[#1a2744] leading-tight" data-id="element-1300">
                          {name}
                        </span>
                        <span className={`text-xs font-semibold ${isActive ? 'text-[#e91e8c]' : 'text-gray-500'}`} data-id="element-1301">
                          £{price}
                        </span>
                      </button>;
                })}
                </div>
              </div>

              {/* STEP 5: Date & Time */}
              <div className={cardClass} data-id="element-1302">
                <h3 className={stepHeadingClass} data-id="element-1303">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1304">STEP 5:</span> Date of
                  Service
                </h3>
                <div className="space-y-6 mt-8" data-id="element-1305">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1306">
                    <div className="space-y-2" data-id="element-1307">
                      <label className={labelClass} data-id="element-1308">Select a date</label>
                      <input type="date" value={date} onChange={e => setDate(e.target.value)} className={inputClass} data-id="element-1309" />
                    </div>
                    <div className="space-y-2" data-id="element-1310">
                      <label className={labelClass} data-id="element-1311">Select a time slot</label>
                      <div className="flex gap-3" data-id="element-1312">
                        {timeSlots.map(slot => <button key={slot} type="button" onClick={() => setTimeSlot(slot)} className={`flex-1 px-4 py-3 rounded-lg text-sm font-medium transition-all border ${timeSlot === slot ? 'bg-[#e91e8c] border-[#e91e8c] text-white shadow-sm' : 'bg-white border-gray-200 text-gray-600 hover:border-[#e91e8c] hover:text-[#e91e8c]'}`} data-id="element-1313">
                            {slot}
                          </button>)}
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-400" data-id="element-1314">
                    For same day bookings, a customer service agent will call
                    you.
                  </p>
                </div>
              </div>

              {/* STEP 6: Access Details */}
              <div className={cardClass} data-id="element-1315">
                <h3 className={stepHeadingClass} data-id="element-1316">
                  <span className="text-[#e91e8c] mr-2" data-id="element-1317">STEP 6:</span> Access
                  Details & Other Info
                </h3>
                <p className="text-sm text-gray-500 mt-3" data-id="element-1318">
                  If your instructions to access the premise was either 'Pick up
                  Keys' or 'Lock Box', please include address for pick up or the
                  code to the lock box here.
                </p>
                <div className="mt-6" data-id="element-1319">
                  <textarea value={accessDetails} onChange={e => setAccessDetails(e.target.value)} placeholder="Enter access details, special instructions, or any other information..." rows={4} className="w-full border border-gray-200 rounded-lg p-4 bg-white text-[#1a2744] focus:outline-none focus:border-[#e91e8c] focus:ring-1 focus:ring-[#e91e8c] transition-all resize-none placeholder-gray-400" data-id="element-1320" />
                </div>
              </div>

              {/* STEP 7: Submit */}
              <div className={cardClass} data-id="element-1321">
                <div className="text-center space-y-4" data-id="element-1322">
                  <h3 className="font-bebas text-2xl md:text-3xl text-[#1a2744]" data-id="element-1323">
                    Ready to Book?
                  </h3>
                  <p className="text-gray-500 text-sm max-w-md mx-auto" data-id="element-1324">
                    Review your details above and click below to confirm your
                    move-in/move-out cleaning. We'll send you a confirmation
                    email right away.
                  </p>
                  <button type="submit" className="bg-[#e91e8c] hover:bg-[#d0187c] text-white px-12 py-4 rounded-full font-semibold tracking-wider text-lg transition-colors shadow-lg hover:shadow-xl" data-id="element-1325">
                    BOOK NOW
                  </button>
                </div>
              </div>
            </form>
          </motion.div>
        </section>

        {/* Explore Our Services */}
        <section className="w-full bg-white py-20 px-4 md:px-12 border-t border-gray-200" data-id="element-1326">
          <div className="max-w-7xl mx-auto" data-id="element-1327">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} className="text-center mb-16" data-id="element-1328">
              <h2 className="font-bebas text-4xl md:text-5xl lg:text-6xl text-[#1a2744] tracking-wide" data-id="element-1329">
                EXPLORE OUR <span className="text-[#e91e8c]" data-id="element-1330">SERVICES</span>
              </h2>
              <p className="text-gray-600 mt-4 max-w-2xl mx-auto" data-id="element-1331">
                Discover our full range of professional cleaning solutions
                tailored to your needs.
              </p>
            </motion.div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1332">
              {[{
              title: 'Basic Home Cleaning',
              desc: 'Regular maintenance to keep your home spotless.',
              link: '/basic-home-cleaning',
              icon: Home
            }, {
              title: 'Spring / Deep Cleaning',
              desc: 'Thorough, top-to-bottom detail cleaning.',
              link: '/spring-deep-cleaning',
              icon: Sparkles
            }, {
              title: 'Commercial Cleaning',
              desc: 'Professional cleaning for your business.',
              link: '/commercial-cleaning',
              icon: Building2
            }, {
              title: 'Contact Us',
              desc: 'Get in touch for custom requests.',
              link: '/contact-us',
              icon: Phone
            }].map((service, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: idx * 0.1
            }} data-id="element-1333">
                  <Link to={service.link} className="group block h-full bg-[#f8f9fa] rounded-xl p-8 hover:shadow-md transition-all border border-gray-100 hover:border-[#5bbcd5]" data-id="element-1334">
                    <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center mb-6 group-hover:bg-[#5bbcd5]/10 transition-colors" data-id="element-1335">
                      <service.icon className="w-6 h-6 text-[#1a2744] group-hover:text-[#5bbcd5] transition-colors" data-id="element-1336" />
                    </div>
                    <h3 className="font-bebas text-2xl text-[#1a2744] mb-3 tracking-wide group-hover:text-[#e91e8c] transition-colors" data-id="element-1337">
                      {service.title}
                    </h3>
                    <p className="text-gray-500 text-sm mb-6 line-clamp-2" data-id="element-1338">
                      {service.desc}
                    </p>
                    <div className="flex items-center text-[#5bbcd5] font-medium text-sm mt-auto" data-id="element-1339">
                      Learn more
                      <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-1340" />
                    </div>
                  </Link>
                </motion.div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1341" />
    </div>;
}